import { Route, Routes } from 'react-router';

import AddNewAdvertisement from './AddNewAdvertisement';
import AdvertisementEdit from './AdvertisementEdit';
import AdvertisementList from './AdvertisementList';

function AdvertisementModule() {
  return (
    <Routes>
      <Route index element={<AdvertisementList />} />
      <Route path="add" element={<AddNewAdvertisement />} />
      <Route path=":id" element={<AdvertisementEdit />} />
    </Routes>
  );
}

export default AdvertisementModule;
